import { select, put } from 'redux-saga/effects';
import { getUuid } from '../../api';

const getDefaultStyle = ({ customLayersConfig }) => customLayersConfig.defaultStyle;

export function* newEmptyLayer() {
  const defaultStyle = yield select(getDefaultStyle);
  const key = getUuid();
  const layer = {
    key,
    label: '',
    filters: {},
    style: defaultStyle,
    isNew: true,
  };

  yield put({
    type: 'CREATE_NEW_CUSTOM_LAYERS',
    payload: { layers: [layer] },
  });
}
